import React from "react";
import theme from "@monorepo/styles/theme";
import { Box, Divider } from "@mui/material";

interface IGridListProps {
  items: Array<JSX.Element>;
}

export const GridList: React.FC<IGridListProps> = ({ items }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${items.length * 2 - 1}, 1fr)`,
        justifyItems: "center",
        alignItems: "center",
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item}
          {index < items.length - 1 && (
            <Divider
              orientation="vertical"
              sx={{ height: "100%", width: "1px", backgroundColor: theme.palette.geyserGray.main }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};